import React, { useState } from 'react';
import { Col, FormGroup, ProgressBar } from 'react-bootstrap';
import Select from 'react-select';
import { SelectNoBorder, videoLinkTypeOptions } from '../../../Components/helper';

const ImageOrVideoLinkInput = ({
  loaderVideo,
  progress,
  handleLinkVideoUpload,
  isImageLink,
  isVideoLink,
  handleLinkImageUpload,
  i,
  imageLink,
  videoLink,
  errors,
  t,
  handleVideoLinkTypeChange,
  videoLinkType,
}) => {
  const [imageLinkPath, setImageLinkPath] = useState(imageLink || '');
  const [videoLinkPath, setVideoLinkPath] = useState(videoLink || '');
  const renderInputField = () => {
    if (isImageLink) {
      return (
        <Col md={4}>
          <FormGroup>
            <div className="input-group form-floating-label fixed-label">
              <input
                type="text"
                onChange={(e) => setImageLinkPath(e?.target?.value, i)}
                name="code"
                className="form-control"
                value={imageLinkPath}
                placeholder={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.IMAGE_LINK_PLACEHOLDER')}
                // onKeyDown={(e) => handleKeyDown(e, i, "image")}
                onBlur={(e) => handleLinkImageUpload(imageLinkPath, i)}
              />
              <label className="asterisk-req">
                {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.IMAGE_LINK')}
                <span>*</span>
              </label>
              <span className="icon-info align-self-center" title={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.PASTE_IMAGE_LINK_HERE')} />
            </div>
            {errors?.[i]?.imageLink && <span className="error-message">{errors?.[i]?.imageLink}</span>}
          </FormGroup>
        </Col>
      );
    }
    if (isVideoLink) {
      return (
        <Col md={4}>
          <FormGroup>
            <div className="input-group form-floating-label fixed-label">
              {!loaderVideo ? (
                <>
                  <div className="w-100px">
                    <Select
                      placeholder="Source"
                      value={videoLinkType}
                      onChange={handleVideoLinkTypeChange}
                      styles={SelectNoBorder}
                      options={videoLinkTypeOptions}
                    />
                  </div>

                  <input
                    type="text"
                    // onKeyDown={(e) => handleKeyDown(e, i, "video")}
                    onChange={(e) => setVideoLinkPath(e?.target?.value, i)}
                    name="code"
                    className="form-control"
                    value={videoLinkPath}
                    placeholder={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.VIDEO_LINK_PLACEHOLDER')}
                    onBlur={(e) => handleLinkVideoUpload(videoLinkPath, i)}
                  />
                  <label className="asterisk-req">
                    {t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.VIDEO_LINK')}
                    <span>*</span>
                  </label>
                  <span className="icon-info align-self-center" title={t('DAM_MAIN_VIEW.ADD_EDIT_VIEW.PASTE_VIDEO_LINK_HERE')} />
                </>
              ) : (
                // <Loader />
                <ProgressBar now={progress} label={`${progress.toFixed(2)}%`} />
              )}
            </div>
            {errors?.[i]?.videoLinkType && <span className="error-message">{errors?.[i]?.videoLinkType}</span>}
            {errors?.[i]?.videoLink && <span className="error-message">{errors?.[i]?.videoLink}</span>}
          </FormGroup>
        </Col>
      );
    }
    return null;
  };

  return renderInputField();
};

export default ImageOrVideoLinkInput;
